// extracted by mini-css-extract-plugin
module.exports = {"section":"Post_section__Q_aS3","box":"Post_box__vFl_b","colL":"Post_colL__c22wF","colR":"Post_colR__Sho9k","vertical":"Post_vertical__DajX6"};